import { MonitoringComponent } from './monitoring.component';
import { MonitoringGuard } from '../core/guards/monitoring.guard';
import { MonitorHttpComponent } from './monitor-http/monitor-http.component';
import { Routes } from '@angular/router';
import { MonitorStatusComponent } from './monitor-status/monitor-status.component';
import {AuthGuard} from '@auth0/auth0-angular';;

export const MONITORING_ROUTES: Routes = [
  {
    path: 'monitoring',
    data: { monitoringView: true },
    component: MonitoringComponent,
    canActivate: [AuthGuard, MonitoringGuard],
    children: [
      { path: 'status', component: MonitorStatusComponent },
      { path: 'http', component: MonitorHttpComponent },
      { path: '**', redirectTo: 'status' }
    ]
  }
];
